<ng-container *ngIf="autoCompletion">

	<div class="auto-completion-table-wrapper">
		<p-table
			data-cy="auto-completion-breakdown-table"
			[value]="tasks"
			[paginator]="true"
			[rows]="20"
			[showCurrentPageReport]="true"
			currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records"
			dataKey="taskInstanceId"
			styleClass="dashboard-data-table"
		>
			<ng-template pTemplate="header">
				<tr>
					<th pSortableColumn="businessDate">
						Date
						<p-sortIcon field="businessDate"></p-sortIcon>
					</th>

					<th pSortableColumn="reportTypeName">
						Report
						<p-sortIcon field="reportTypeName"></p-sortIcon>
					</th>

					<th pSortableColumn="reasonCode">
						Outcome
						<p-sortIcon field="reasonCode"></p-sortIcon>
					</th>

					<th class="action-column">
						Action
					</th>
				</tr>
			</ng-template>

			<ng-template pTemplate="body" let-task>
				<tr>
					<td class="date-column">
						{{ formatBusinessDate(task.businessDate) }}
					</td>

					<td class="report-column">
						{{ task.reportTypeName }}
					</td>

					<td>
						<span
							class="auto-completion-status"
							[ngClass]="getReasonClass(task.reasonCode)"
						>
							{{ getReasonLabel(task.reasonCode) }}
						</span>
					</td>

					<td class="action-column">
						<button
							type="button"
							class="auto-completion-view-link"
							title="Open task in new tab"
							(click)="onViewTask(task)"
						>
							<span>View</span>
							<i class="pi pi-arrow-right"></i>
						</button>
					</td>
				</tr>
			</ng-template>

			<ng-template pTemplate="emptymessage">
				<tr>
					<td colspan="4">
						<div class="dashboard-empty-state">
							<span>No auto-completed tasks found.</span>
						</div>
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>
</ng-container>
